module.exports = __webpack_public_path__ + "media/images/lavita_banner/banner__between--en-ef5a8ed01dc8bc7eee2815464f758e72.jpg";